import { gql, useQuery } from "@apollo/client";
import type {
  GetRateAgreementById,
  GetRateAgreementByIdVariables
} from "./schema/GetRateAgreementById";

export const getRateAgreementByIdQuery = gql`
  query GetRateAgreementById($id: ID!) {
    rates {
      rateAgreementById(rateAgreementId: $id) {
        id
        name
        description
        carrier
        serviceMethod
        auditTrail {
          changedBy
          changedAt {
            utcDateTime
          }
          action
        }
        rateTables {
          id
          type
          currency
          description
          validFrom
          validTo
          useMinimumProcedure
          rateStructure {
            pickupLocationFilters {
              column
              operator
            }
            deliveryLocationFilters {
              column
              operator
            }
            serviceOptionFilters {
              column
              operator
            }
            primaryQuantity {
              column
              unit
              ranges {
                upperBound
                costType
              }
            }
            additionalQuantities {
              column
              unit
              ranges {
                upperBound
              }
            }
          }
        }
      }
    }
  }
`;

export function useRateAgreementById(id: string) {
  const { data, loading, error } = useQuery<
    GetRateAgreementById,
    GetRateAgreementByIdVariables
  >(getRateAgreementByIdQuery, {
    variables: { id },
    skip: !id
  });
  const rateAgreement = data?.rates?.rateAgreementById ?? null;
  return {
    rateAgreement,
    // Treat as loaded as soon as we have data — avoids re-showing skeletons
    // when navigating between rate tables of the same already-cached agreement.
    loading: loading && rateAgreement == null,
    error
  };
}
